import React from "react";
import SideBar from "./IndustryReportSidebar";

export default function IndustryReportLayout({ children }) {
  return (
    <>
      <SideBar>
        {children}
      </SideBar>
    </>
  );
}
